import React from "react";
import "./why-blendsafe.css";

export default function WhyBlendSafe({ methodologyHref = "/methodology" }) {
  return (
    <section className="bs-research" aria-labelledby="bs-research-heading" data-testid="why-blendsafe-section">
      <p className="bs-eyebrow">WHY BLENDSAFE</p>
      <h2 id="bs-research-heading" data-testid="why-blendsafe-heading">
        If we can’t cite it,<br /><mark>we don’t publish it.</mark>
      </h2>
      <p className="bs-intro">
        A US-licensed pharmacist researches each combination, documents the evidence and approves the
        finding before publication. Every published finding links to its sources—so you can see what
        supports it.
      </p>
      <div className="bs-columns">
        <ol className="bs-steps">
          <li className="bs-step">
            <span className="bs-number" aria-hidden="true">01</span>
            <span className="bs-step-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <path d="M14 2v6h6M8 12h8M8 16h8M8 8h2" />
              </svg>
            </span>
            <div className="bs-step-copy">
              <h3>Start with the medication label</h3>
              <p>We check the exact medication label on DailyMed.</p>
            </div>
          </li>
          <li className="bs-step">
            <span className="bs-number" aria-hidden="true">02</span>
            <span className="bs-step-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <circle cx="10.5" cy="10.5" r="7.5" />
                <path d="m16 16 6 6" />
              </svg>
            </span>
            <div className="bs-step-copy">
              <h3>Look for supporting evidence</h3>
              <p>When the label does not address the combination, we consult an approved supporting source.</p>
            </div>
          </li>
          <li className="bs-step">
            <span className="bs-number" aria-hidden="true">03</span>
            <span className="bs-step-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <rect x="5" y="4" width="14" height="18" rx="2" />
                <rect x="9" y="2" width="6" height="4" rx="1" />
                <path d="m9 13 2 2 5-5" />
              </svg>
            </span>
            <div className="bs-step-copy">
              <h3>Explain and review</h3>
              <p>Each published result includes its sources, pharmacist’s name and review date.</p>
            </div>
          </li>
        </ol>
        <aside className="bs-sources" aria-label="Research sources">
          <h3>Our research sources</h3>
          <div className="bs-primary">
            <svg className="bs-book" aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M12 5c-3-2-6-2-10-1v15c4-1 7-1 10 1 3-2 6-2 10-1V4c-4-1-7-1-10 1Zm0 0v15" />
            </svg>
            <div>
              <strong>DailyMed</strong>
              <em>Medication label first</em>
            </div>
          </div>
          <ul className="bs-source-list">
            <li>PubMed</li>
            <li>FDA.gov</li>
            <li>AAD</li>
            <li>JAAD</li>
            <li>DermNet</li>
            <li>Cochrane Library</li>
            <li>Drugs.com</li>
            <li>Medscape</li>
          </ul>
          <p className="bs-note">Sources inform our findings. Listing a source does not imply endorsement.</p>
        </aside>
      </div>
      <a className="bs-method" href={methodologyHref} data-testid="why-blendsafe-methodology-link">
        Explore our methodology <span aria-hidden="true">→</span>
      </a>
    </section>
  );
}
